import { hostnames } from 'features/common/config/envConfig';

const baseMarketplaceAppUrl = {
  [hostnames.internal]: 'https://marketplace-staging.sitecore-staging.cloud',
  [hostnames.localhost]: 'https://marketplace-dev.sitecore-staging.cloud',
  [hostnames.dev]: 'https://marketplace-dev.sitecore-staging.cloud',
  [hostnames.qa]: 'https://marketplace-qa.sitecore-staging.cloud',
  [hostnames.staging]: 'https://marketplace-staging.sitecore-staging.cloud',
  [hostnames.beta]: 'https://marketplace-beta.sitecorecloud.io',
  [hostnames['pre-production']]: 'https://marketplace-preprod.sitecorecloud.io',
  [hostnames.production]: 'https://marketplace.sitecorecloud.io',
};

export const getBaseMarketplaceAppUrl = (): string =>
  baseMarketplaceAppUrl[window.location.hostname];
